import { Typography } from '@mui/material'
import { Breadcrumbs } from '@mui/material'
import React,{useEffect, useState} from 'react'
import { Link } from 'react-router-dom'
import Instruction from './Instruction'
import axios from 'axios'
import { BASE_URL } from '../../../constants'

function InstructionList() {
  const [instructionData, setInstructionData] = useState([]);

  useEffect(()=>{
    axios.get(`${BASE_URL}/instructions`, { 
      headers: {
        "authorization": `${localStorage.getItem('token')}` ,
        "Content-Type": "application/json",
      }}).then((res) => {
        setInstructionData(res.data)
  })
  },[])

  return (
    <div className='full-container'>
        <div style={{margin:'0px 10px'}}>
            <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" to="/programs" >
                Program
            </Link>
        
            <Typography  color="text.primary">Instructions</Typography>
            </Breadcrumbs>
        </div>
        <div>
        {instructionData && instructionData.length > 0 && instructionData.map((instruction, index)=>{
            return <Instruction key={index+1} instruction={instruction} />
          })
        }
        {instructionData && instructionData.length <= 0 &&<div style={{
                display:'flex', 
                backgroundColor:'#def1fc', 
                border:'solid 1px #ccc',
                margin:'10px 0px'
             }}
             >
              <div style={{ display:'flex', padding: '5px', flexDirection:'column', alignItems:'center'}}>
                  <Typography sx={{fontSize:'16px'}} > No instruction to display. </Typography>
              </div>
            </div>
         
        }
            
        </div>
</div>
  )
}

export default InstructionList